import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../util/Rest';

const initialData = {
  letterData: [],
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  requestLettersCode: [],
  requestedLettersData: {},
  requestLettersStatus: null,
};

const slice = createSlice({
  name: 'letterHistory',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchLetterData: (state, action) => {
      state.letterData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.response;
      state.isLoading = false;
    },
    getRequestlettersData: (state, action) => {
      state.requestLettersCode = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.letterHistoryLoading = false;
    },
    resetRequestLettercode: (state) => {
      state.requestLettersCode = [];
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.letterHistoryLoading = false;
    },
    fetchRequestLetterData: (state, action) => {
      state.requestedLettersData = action.payload?.response;
      state.successMsg = action.payload?.message;
      state.isLoading = false;
      state.requestLettersStatus = action.payload.status;
    },
    deleteLetterRequest: (state, action) => {
      state.requestLettersStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    comdeleteLetterRequest: (state, action) => {
      state.requestLettersStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetRequestLetterData: (state, action) => {
      state.requestedLettersData = {};
      state.isLoading = false;
      state.requestLettersStatus = null;
      state.successMsg = null;
      state.errorMsg = null;
    },
  },
});

export default slice.reducer;

// Actions

const {
  fetchLetterData,
  fetchStart,
  fetchError,
  getRequestlettersData,
  resetRequestLetterData,
  fetchRequestLetterData,
  resetRequestLettercode,
  deleteLetterRequest,
  comdeleteLetterRequest,
} = slice.actions;

export const fetchLetter = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`lettermaintenance/find/all/lettercode`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchLetterData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchRequestLetters = (accountNumber, disposition) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`letter/request/get/eligible/letter/${accountNumber}/${disposition}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getRequestlettersData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchSaveRequestLetters = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`letter/request/letter/request`, details)
      .then((data) => {
        if (data && data.status && data?.data?.status === 400) {
          dispatch(fetchError(data?.data?.message));
        } else if (data && data.status && data.status === 200) {
          dispatch(fetchRequestLetterData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const deleteLetterRequested = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`letter/request/delete/requestedletters`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(deleteLetterRequest(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const comDeleteLetterRequested = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`newlettermaintenance/delete/letterhistory`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(comdeleteLetterRequest(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetRequestLetterCode = () => {
  return (dispatch) => {
    dispatch(resetRequestLettercode());
  };
};
export const resetRequestLetters = () => {
  return (dispatch) => {
    dispatch(resetRequestLetterData());
  };
};
